import { reactive } from '@vue/composition-api';
import axios from 'axios';
import { session } from '@utils/storage';
import { refreshToken } from '@/useable/login';
import { Message } from 'element-ui';
import { pending, removeRepeatPending } from '@/useable/cancelRequest';

axios.defaults.baseURL = process.env.VUE_APP_API_URL;
const { CancelToken } = axios;

// interceptors
axios.interceptors.request.use((config: any) => {
  // 移除重复请求
  removeRepeatPending(config);
  config.cancelToken = new CancelToken((c) => {
    pending.push({
      url: config.url,
      method: config.method,
      params: config.params,
      data: config.data,
      cancel: c,
    });
  });
  if (!config.url.includes('/api')) {
    const { token } =  reactive(JSON.parse(session.get('user-infor') || '{}'));
    Object.assign(config.headers, { authentication: token });

    if (!config.url.includes('refreshToken')) {
      (async () => {
        await refreshToken();
      })();
    }
  }
  return config;
}, error => Promise.reject(error));

// token 过期响应
axios.interceptors.response.use((res) => {
  removeRepeatPending(res.config);
  // if (res.request?.responseURL?.includes('/data/finance/interface/apply')) {
  //   return res;
  // }
  if (res?.data?.code && ![2000, 7060, 3653, 3654, 3655, 7062].includes(res.data.code)) {
    Message.error(res.data.message);
  }

  return res;
}, (error) => {
  if (axios.isCancel(error)) {
    return new Promise(() => {});
  } 
  return Promise.reject(error);
  
});

interface Module {
  [key: string]: any
}

const FileType: any = {
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  csv: 'text/csv',
  ppt: 'application/vnd.ms-powerpoint',
  pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  jpeg: 'image/jpeg',
  jpg: 'image/jpeg',
  png: 'image/png',
  rar: 'application/x-rar-compressed',
  pdf: 'application/pdf',
  zip: 'application/zip',
  ofd: 'application/ofd',
};

const downFile = (result: any) => {
  const fileName = window.decodeURI(result.headers['content-disposition']?.split('filename=')[1]);  // 文件名
  const type = fileName.split('.')[1] ? FileType[fileName.split('.')[1]] : FileType.zip;  // 文件类型
  const link = document.createElement('a');
  const blob = new Blob([result.data], { type });
  link.style.display = 'none';
  link.href = URL.createObjectURL(blob);
  link.download = fileName;
  link.click();
  document.body.appendChild(link);
  URL.revokeObjectURL(link.href);
};

const modules: Module = {};

const files = (require as any).context('@service', true, /\.ts$/);

files.keys().forEach((key: any) => {
  if (key === './index.ts') return;
  const apiFiles = files(key).default;

  if (!apiFiles) return;

  key = key.replace(/(\.\/|\.ts)/g, '');
  const map = {};

  Object.keys(apiFiles).forEach((api: string) => {
    if (!apiFiles[api]) return;

    const { responseType } = apiFiles[api];
    // eslint-disable-next-line prefer-const
    let { url, method, headers } = apiFiles[api];

    url = `/v1${url}`;
    // url = process.env.VUE_APP_API_ENV === 'dev' ? url : `/v1${url}`;
    method = method === undefined ? 'get' : method;
    headers = headers === undefined ? {} : headers;

    const apiConfig = { url, method, headers, responseType} as any;

    map[api] = (params: any) => new Promise((resolve, reject) => {
      axios({ ...apiConfig, [method === 'get' ? 'params' : 'data']: params }).then((res: any) => {
        if ( responseType === 'blob') downFile(res);
        resolve(res.data);
      }).catch((err: any) => {
        reject(err);
      });
    });
  });

  modules[key] = map;
});

export default modules;

